import { filterGroups } from './const';
import { Column } from '@simplywallst/ui-core';
import { GroupLabel, RowWithRule } from './styled';
import DynamicFilter from '../DynamicFilter';
import { memo } from 'react';

const MemoDynamicFilter = memo(DynamicFilter);

interface Props {
  onChange: (id: string, rule: string) => void;
  onToggle: (toggledId: string, rule?: string) => void;
  toggledFilters: string[];
  rules: Record<string, string>;
}
export function DeprecatedFilters({
  onChange,
  onToggle,
  toggledFilters,
  rules,
}: Props) {
  return filterGroups.map((filterGroup) => (
    <div key={filterGroup.label}>
      <RowWithRule>
        <Column>
          <GroupLabel>{filterGroup.label}</GroupLabel>
        </Column>
      </RowWithRule>
      {filterGroup.filters.map(
        ({
          id,
          label,
          subLabel,
          labels,
          type,
          defaultValue,
          valueResolver,
          step,
          min,
          max,
          softMin,
          softMax,
          titleFormatter,
          rule,
          ruleToValue,
          untoggledRule,
        }) => {
          const toggled = toggledFilters.includes(id);
          return (
            <MemoDynamicFilter
              id={id}
              key={id}
              currentRule={rules[id]}
              defaultValue={rules[id] || defaultValue}
              label={label}
              subLabel={subLabel}
              labels={labels}
              max={max}
              min={min}
              onChange={onChange}
              onToggle={onToggle}
              rule={rule}
              ruleToValue={ruleToValue}
              softMax={softMax !== undefined ? softMax : max}
              softMin={softMin !== undefined ? softMin : min}
              step={step}
              titleFormatter={titleFormatter}
              toggled={toggled}
              type={type}
              valueResolver={valueResolver}
              untoggledRule={untoggledRule}
            />
          );
        }
      )}
    </div>
  ));
}
